import React, { useEffect, useState, useContext } from "react";
import { Box, CircularProgress, Grid, Paper, Chip, Autocomplete, TextField, Typography, Pagination } from "@mui/material";
import ApiService from "../../functions/apiService";
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import moment from "moment-timezone";
import MyTable from "../../components/Schedule/MyTable";
import { varFormatTime } from '../../utils/helperFunctions';
import AuthContext from '../../context/AuthContext';
import { DataGrid } from '@mui/x-data-grid';

export default function ViewBids() {
	const { user } = useContext(AuthContext);
	const [loading, setLoading] = useState(false);
	const [date, setDate] = useState(new Date());
	const [allData, setAllData] = useState([]);
	const [allowedVars, setAllowedVars] = useState({})
	const [employees, setEmployees] = useState([])
	const [assignedTo, setAssignedTo] = useState(null);
	const [action, setAction] = useState("");
	const [listType, setListType] = useState("");
	const [refresh, setRefresh] = useState(false);
	// const [currentPage, setCurrentPage] = useState(1);
	// const rowsPerPage = 100;
	// const [paginatedRows, setPaginatedRows] = useState([]);
	// const totalPages = Math.ceil(alldata.length / rowsPerPage);

	let getAllowedVars = () => {
		ApiService.get('/v3Variables')
			.then((res) => {
				setAllowedVars(res?.data?.data)
			}).catch(({ error }) => {
				console.log('error', error)
			});
	}

	let columns = [
		{
			field: 'Shift_Date', headerName: 'Shift Date', flex: 1, minWidth: 100,
			valueGetter: (params) => { return moment(params?.row?.Shift_Date).format('MM/DD/YYYY') }
		},

		{
			field: 'Member', headerName: 'Employee', flex: 1, minWidth: 160, valueGetter: (params) => params?.row?.employee?.fullName
		},

		{
			field: 'Shift', headerName: 'Shift', flex: 1, minWidth: 100,
			renderCell: (params) => {
				return (
					<Chip style={{ width: '60px' }}
						label={params?.row?.overtime_shift?.Shift_Code == 2 ? 'Day' : 'Night'}
						className={params?.row?.overtime_shift?.Shift_Code == 2 ? 'day-chip' : 'night-chip'} />
				)
			}
		},

		{
			field: 'bid', headerName: '', flex: 1, minWidth: 130, valueGetter: (params) => params?.row?.Action + " " + params?.row?.Value
		},

		{
			field: 'status', headerName: 'Status', flex: 1, minWidth: 130, valueGetter: (params) => params?.row?.Status
		},

		{
			field: 'date', headerName: 'Created on', flex: 1, minWidth: 100,
			valueGetter: (params) => { return moment(params?.row?.Create_Time).format('MM/DD/YYYY') + " " + varFormatTime(moment(params?.row?.Create_Time).format('HH:mm'), user?.Time_Format) }
		},

		{
			field: 'dateChange', headerName: 'Changed on', flex: 1, minWidth: 100,
			// valueGetter: (params) => { return moment(params?.row?.Change_Time).format('MM/DD/YY') }
		},
	];

	const viewBidsList = () => {
		setLoading(true)
		ApiService.post("/viewBids", {
			"date": date,
			"Emp_Code": assignedTo?.value,
			"Action": action
		})
			.then((data) => {
				setAllData(data?.data)
				setLoading(false)
			})
			.catch((error) => {
				setLoading(false)
			});
	};

	const viewOtList = () => {
		setLoading(true)
		ApiService.post("/viewOvertimeSignups", {
			"date": date,
			"Emp_Code": assignedTo?.value,
		})
			.then((data) => {
				setAllData(data?.data)
				setLoading(false)
			})
			.catch((error) => {
				setLoading(false)
			});
	};

	const loadEmployees = () => {
		setLoading(true);
		ApiService.get('/employees-list?search=')
			.then(({ data }) => {
				var tempArr = []
				data?.data.map((emp) => {
					var obj = {
						label: `${emp?.employee_assignment?.EA_Rank} ${emp?.fullName}`,
						value: emp?.Emp_Code
					}
					tempArr.push(obj)
				})
				setEmployees(tempArr)
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
			})
	}

	useEffect(() => {
		getAllowedVars()
		loadEmployees()
	}, [])

	useEffect(() => {
		if (listType != '')
			if (action == '') {
				viewOtList()
			}
			else {
				viewBidsList()
			}
	}, [action, refresh])

	return (
		<>
			<Box style={{ marginTop: "1rem" }}>
				<Grid container spacing={2} columns={{ xs: 8, sm: 8, md: 12 }}>
					<Grid item xs={12}>
						<Paper className="p-3">
							<Box className='d-flex justify-content-between'>
								<Typography variant="h6">View Employee Actions</Typography>
								<div style={{ display: 'flex', gap: '10px' }}>

									{allowedVars && Object.keys(allowedVars).includes('ACCEPT_SHIFT_PRE_BID') &&
										<span className={listType == 'PRE-BID' ? 'tab-active' : 'tab-white'}
											onClick={() => {
												setAction('PRE-BID')
												setListType('PRE-BID')
												setDate(new Date())
												setAssignedTo(null)
											}}> Pre Bid </span>}

									{/* {allowedVars && Object.keys(allowedVars).includes('ACCEPT_SHIFT_PRE_DECLINE') &&
										<span className={listType == 'PRE_DECLINE' ? 'tab-active' : 'tab-white'}
											onClick={() => {
												setAction('PRE_DECLINE')
												setListType('PRE_DECLINE')
												setDate(new Date())
												setAssignedTo(null)
											}}> Pre Decline </span>} */}

									{allowedVars && Object.keys(allowedVars).includes('ACCEPT_SHIFT_PRE_PREFERENCE') &&
										<span className={listType == 'Pre-Preference-Add' ? 'tab-active' : 'tab-white'}
											onClick={() => {
												setAction('Pre-Preference-Add')
												setListType('Pre-Preference-Add')
												setDate(new Date())
												setAssignedTo(null)
											}}> Pre Preference </span>}

									{allowedVars && Object.keys(allowedVars).includes('V3_OVERTIME_SIGNUP_FORM') &&
										<span className={listType == 'OT' ? 'tab-active' : 'tab-white'}
											onClick={() => {
												setListType('OT')
												setAction('')
												setDate(new Date())
												setAssignedTo(null)
											}}> Overtime Signup </span>}
								</div>
							</Box>

							<Grid container spacing={2} className="px-3 py-2 d-flex align-items-center">

								<Grid xs={3} md={2.5} className="mt-4">
									<label style={{ fontSize: '14px' }}>Date Until</label>
									<Box className='mt-1'>
										<LocalizationProvider dateAdapter={AdapterDateFns}>
											<DatePicker
												value={date}
												onChange={(e) => setDate(e)}
												disablePast
												sx={{
													width: "100%",
													"& .MuiInputBase-root": {
														height: '48px',
														fontSize: '14px'
													},
												}}
												dateInputIcon={<CalendarTodayIcon />}
											/>
										</LocalizationProvider>
									</Box>
								</Grid>

								<Grid xs={3} md={2.5} className="mt-4 px-2">
									<label style={{ fontSize: '14px' }}>Employees</label>
									<Box className='mt-1'>
										<Autocomplete
											options={employees}
											value={assignedTo}
											onChange={(event, newValue) => { setAssignedTo(newValue) }}
											sx={{
												"& .MuiInputBase-root": {
													height: "48px",
													fontSize: "14px",
													display: "flex",
													alignItems: "center"
												}
											}}
											renderInput={(params) => (
												<TextField
													{...params}
													placeholder="Select Employee"
												/>
											)}
										/>
									</Box>
								</Grid>

								<Grid item xs={12} sm={12} md={2} className="d-flex" style={{ marginTop: '35px', gap: 20 }}>
									<ButtonTheme
										color='primary'
										onClick={() => setRefresh(!refresh)}>
										Refresh
									</ButtonTheme>
								</Grid>

							</Grid>
						</Paper>
					</Grid>

					<Grid item xs={12}>
						{loading &&
							<Paper className="w-100 d-flex justify-content-center align-items-center py-4"
								style={{ height: '495px' }}>
								<CircularProgress />
							</Paper>}

						{!loading &&
							<>
								{allData.length > 0 &&
									<Paper className="p-3">

										{/* <MyTable
											rows={allData}
											columns={columns}
											hideFooter={true}
											checkboxSelection={false}
											selectedRows={selectedEmp}
			                onRowSelectionModelChange={onRowSelectionModelChange}
										/> */}

										<DataGrid
											rows={allData}
											columns={columns}
											checkboxSelection={false}
											hideFooter={true}
											sx={{
												"& .MuiDataGrid-columnHeaderTitleContainer": {
													display: "flex !important",
												},
												"& .MuiTablePagination-selectLabel": {
													marginBottom: "0 !important"
												},
												"& .MuiTablePagination-displayedRows": {
													marginBottom: "0 !important"
												},
												"& .MuiDataGrid-columnHeader": {
													minWidth: "100px",
												},
											}}
										/>

										{/* <Pagination
											count={totalPages}
											color="primary"
											className="mt-3 mb-3 d-flex"
											style={{ justifyContent: 'end' }}
											page={currentPage}
											onChange={(event, page) => setCurrentPage(page)}
										/> */}
									</Paper>}
							</>}

						{!loading && allData?.length === 0 &&
							<Paper className='d-flex flex-column align-items-center justify-content-center' style={{ height: 495, width: "100%" }}>
								<img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
								<span className='mt-4' style={{ color: '#555555' }}>
									{listType == '' ? "Please Select Action" : "No Results Found"}
								</span>
							</Paper>}
					</Grid>
				</Grid>
			</Box>
		</>)
}